<template>
    <div class="page">
        <div class="head-view">
            <div class="head-box">
                <img @click="tokVideo" src="../assets/images/logo.png" alt="">
                <span @click="tokAbout" :style="currentIndex==1?'border-color: #FD4F00;':''">关于TOKTOK</span>
                <span @click="tokStory" :style="currentIndex==2?'border-color: #FD4F00;':''">精酿故事</span>
                <span @click="tokStore" :style="currentIndex==3?'border-color: #FD4F00;':''">所有门店</span>
                <span @mouseover="showShop" @mouseleave="hideShop" :style="currentIndex==4?'border-color: #FD4F00;':''">精酿商城</span>
                <div class="shop-box" v-show="currentIndex==4">
                    <img src="../assets/images/shopcode2.png" alt="">
                    <div class="shop-box-content">
                        <img src="../assets/images/slogan.png" alt="">
                        <img src="../assets/images/arrow.png" alt="">
                        <span>TOKTOK精酿商城</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="video" class="video-box" ref="videoBox">
            <!-- <img @click="play()" v-show="!videoStatus" src="../assets/images/play.png" alt=""> -->
            <video ref="player" autoplay controls loop muted src="http://cdn.toktok.beer/toktok/toktok_index.mp4"></video>
        </div>
        <div id="about" class="about-box" ref="aboutBox">
            <div>关于TOKTOK</div>
            <span></span>
            <div>
                TOKTOK是一家精酿啤酒厂牌，品牌理念是Everything is OK，致力于让人们品尝来自全国各地啤酒厂生产的新鲜啤酒。<br>
                美丽的色泽、浓郁的香气、细腻的口感，用精酿啤酒中的"故事"向您缓缓道来。<br>
                我们采用专利特色外带桶运输，保鲜黑科技，品质有保障。让每一位顾客在家中，就可以体验到啤酒厂新鲜出桶的原滋原味精酿鲜啤。
            </div>
            <img src="../assets/images/morehema.png" alt="">
        </div>
        <div id="story" class="pic-box" ref="storyBox">
            <div class="pic-story" ref="picStory">
                <span></span>
                <span>探索享受啤酒的新方式。</span>
                <span>美丽的色泽、浓郁的香气、细腻的口感<br>TOKTOK用精酿啤酒中的"故事"<br>向您缓缓道来。</span>
            </div>
            <div class="pic-view">
                <img src="http://cdn.toktok.beer/toktok/img01.png" alt="">
                <div class="pic-text">
                    <span>颜色Color</span>
                    <span>清爽的淡金色、自然的浅稻草色、怀旧的琥珀色、<br>厚重的棕色、诱人的红色...<br>麦芽决定了精酿啤酒倒入玻璃杯中的色泽。<br>酿酒师用来自世界各地的优质麦芽搭配，创造出想象中的各种颜色。</span>
                </div>
            </div>
            <div class="pic-view">
                <img src="http://cdn.toktok.beer/toktok/img02.png" alt="">
                <div class="pic-text">
                    <span>香气Aroma</span>
                    <span>热带水果、蜂蜜、鲜花、麦香、烤面包 ..<br> 入口之前，在鼻尖开启一场醇香之旅。<br> 酿酒师以各种比例组合水果的酯香、麦芽的芳香、啤酒花香，让精酿啤酒散发多种香气。</span>
                </div>
            </div>
            <div class="pic-view">
                <img src="http://cdn.toktok.beer/toktok/img03.png" alt="">
                <div class="pic-text">
                    <span>风味Taste</span>
                    <span>浓郁的麦芽味、清爽的苦味、醇厚的甜味、新鲜的果味...<br> 精酿啤酒拥有100多种世界公认的啤酒风格，在酿酒师的努力下，数量还在逐年增多。<br> 相同风格的精酿啤酒，根据地区水质、酿造时间、酵母种类、季节作物的不同，尤其是酿酒师的技术和趣味性的差异，也会使味道千变万化。</span>
                </div>
            </div>
        </div>
        <div id="store" class="store-div" ref="storeBox">
            <div class="store-divView">
                <div class="store-left">
                    <span>TOKTOK门店信息</span>
                    <span></span>
                    <div class="store-left-ti">
                        <span>
                          TOKTOK已在广州开设10余家线下分店<br>
                          我们提供24小时休闲服务，白天提供咖啡、面包、茶饮，晚上提供精酿啤酒供你享受，提倡“日清醒·夜微醺”的休闲生活理念，味觉享受与精致生活尽在TOKTOK。
                        </span>
                        <img src="../assets/images/hema.png" alt="">
                    </div>
                </div>
                <div class="store-right">
                    <div class="stores-box" v-for="(item, index) in storeList" :key="index">
                        <div class="stores-list">
                            <span>{{item.name}}</span>
                            <span v-show="item.tags!=''" :style="item.tags=='敬请期待'?'background: rgba(0, 0, 0, 0.28)':''">{{item.tags}}</span>
                        </div>
                        <div class="stores-adress">
                            <img src="../assets/images/location.png" alt="">
                            <span>{{item.ad}}</span>
                        </div>
                        <div class="stores-time" style="margin-bottom: 24px;">
                            <img src="../assets/images/time.png" alt="">
                            <span>{{item.time}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="shop" class="footer-div">
            <div class="footer-pic">
                <img src="../assets/images/logo.png" alt="">
                <div class="toktok-media" style="margin: 48px 0 40px auto;">
                    <span>微信公众号</span>
                    <img src="../assets/images/gongzhonghao.png" alt="">
                    <span>TOKTOK官方媒体：</span>
                </div>
                <div class="toktok-media" style="margin: 48px 0 40px 40px;">
                    <span>精酿商城小程序</span>
                    <img src="../assets/images/shopcode.png" alt="">
                    <span></span>
                </div>
            </div>
            <div class="footer-msg">
                <div class="footer-tips">
                    <span>TOKTOK温馨提示：</span>
                    <span>1. 饮酒请适量，小饮怡情，大饮伤身。喝酒不宜开车，请勿酒后驾驶。</span>
                    <span>2. 未成年人不得饮酒，孕妇和儿童不宜饮酒。</span>
                </div>
                <div class="footer-copyright" @click="beianClick()">
                    <span>版权所有 ©{{tYear}} 广州行深科技有限公司</span>
                    <span>粤ICP备17037030号</span>
                    <span>信息产业部备案管理系统</span>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { isElementNotInViewport} from "@/action/utils.js";
export default {
    name:'index',
    data(){
        return{
            videoStatus: false,
            currentIndex: 0,
            temporaryIndex: 0,
            storeList: [
                {
                    name: '市二宫店',
                    tags: '新店',
                    ad: '广州市海珠区江南大道中89号之四6998LUCK B114铺（负一层）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?newAdvance=false&reserveMode=0&payOpenId=&entrance=80&tenantId=10215149&restaurantViewId=&paySource=0&minaId=&spuId=&orderBizTag=0&shopId=601426200&tableNum=29866410&brandId=&authGeo=undefined'
                },
                {
                    name: '龙洞店',
                    tags: '新店',
                    ad: '广州市天河区迎龙路1号1160室',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?shopId=600326998&restaurantViewId=172288&cacheKey=1405742492195807307_600326998_5.54.05&wxAppVersion=5.54.05&platform=81&tenantId=10215149&appId=wx1fde2c33280d64b6&bizType=4&multiShop=1&orderChannel=91'
                },
                {
                    name: '花地湾店',
                    tags: '新店',
                    ad: '广东省广州市荔湾区东漖北路与浣花路交汇东北',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?shopId=600450711&restaurantViewId=172288&cacheKey=1405742492195807307_600450711_5.54.05&wxAppVersion=5.54.05&platform=81&tenantId=10215149&appId=wx1fde2c33280d64b6&bizType=4&multiShop=1&orderChannel=91'
                },
                {
                    name: '星寰广场店',
                    tags: '',
                    ad: '越秀区侨光西路11号星寰国际商业广场负一楼（南门旋转楼梯附近）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?shopId=601086122&restaurantViewId=172288&cacheKey=1405742492195807307_601086122_5.43.02&wxAppVersion=5.43.02&platform=81&tenantId=10215149&appId=wx1fde2c33280d64b6&bizType=4&multiShop=1&orderChannel=91'
                },
                {
                    name: '设计之都店',
                    tags: '',
                    ad: '广州市白云区鹤龙街道白云区黄边北路150号设计之都时光汇1030铺',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-main/pages/main/index.html?multiShop=1&scanId=1673084916430-56557-9712&reserveMode=0&t=1673084916416&shopId=600795330&uuid=null&payMode=1&entrance=43&fromShopList=1&sign=ef3154265655d2c865371acfe2271f77&tenantId=10215149&qrcodeType=null&paySource=152&newAdvance=true&bizType=1&funcMode=1&autoTakeOrder=1&payOpenId=&accountMode=2&tableNum=&bizMode=1&dishSource=0&orderBizTag=1&scene=0'
                },
                {
                    name: '合生广场店',
                    tags: '',
                    ad: '广州市海珠区叠景路168号170号合生广场101房之九铺',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?scanId=1661332908472-7456-271&reserveMode=0&t=1661332908457&shopId=600643920&uuid=1rPdk9z3Ccm&payMode=2&entrance=80&sign=cf76d299b0a24bb9d030a6283ba77033&tenantId=10215149&qrcodeType=1&funcMode=1&bizType=0&autoTakeOrder=1&accountMode=2&payOpenId=&tableNum=18216011&dishSource=0&bizMode=1&perceptionPage=true&orderBizTag=0&scene=0'
                },
                {
                    name: '天河新天地店',
                    tags: '',
                    ad: '广州市天河区天源路5号天河新天地首层L137号商铺',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?newAdvance=false&reserveMode=0&payOpenId=null&entrance=80&tenantId=10215149&restaurantViewId=&paySource=0&minaId=&spuId=&orderBizTag=0&shopId=600348263&tableNum=16226229'
                },
                {
                    name: '天河北店',
                    tags: '',
                    ad: '广州市天河区天河北路628号保利中宇广场首层301铺之二',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?scanId=1652758167418-1379-48137&reserveMode=0&t=1652758167398&shopId=600561713&uuid=1okujH21msd&payMode=2&entrance=80&sign=21238d9ffc4af689ac62322171fa521a&tenantId=10215149&qrcodeType=1&funcMode=1&bizType=0&autoTakeOrder=0&accountMode=1&payOpenId=null&tableNum=16226310&dishSource=0&bizMode=1&perceptionPage=true&orderBizTag=0&scene=0'
                },
                {
                    name: '黄埔古港店',
                    tags: '',
                    ad: '广州市海珠区石基路512号古港新地C1079-1080（黄埔古港景观区旁）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?newAdvance=false&reserveMode=0&payOpenId=null&entrance=80&tenantId=10215149&restaurantViewId=&paySource=0&minaId=&spuId=&orderBizTag=0&shopId=600515518&tableNum=15122827'
                },
                {
                    name: '广州荔枝湾店',
                    tags: '',
                    ad: '广州市荔湾区龙津西路94号古玩城D103铺（荔枝湾景区旁）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?payOpenId=null&minaId=&newAdvance=false&orderBizTag=0&reserveMode=0&restaurantViewId=&tenantId=10215149&tableNum=14489292&paySource=null&spuId=&shopId=600509146&entrance=40'
                },
                {
                    name: '米酷店（万科云城)',
                    tags: '',
                    ad: '广州市天河区万科云城米酷B4栋107、108铺（近天河智慧城地铁B出口）',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index?newAdvance=false&reserveMode=0&payOpenId=null&entrance=80&tenantId=10215149&restaurantViewId=&paySource=null&minaId=&spuId=&orderBizTag=0&shopId=600343939&tableNum=10732595',
                },
                {
                    name: '黄埔南村店',
                    tags: '',
                    ad: '广州市百合三街 6 号 101 铺',
                    time: '营业时间：早08:10-晚23:59',
                    opening: true,
                    path: 'diancan-menu/pages/menu/index.html?shopId=600576175&restaurantViewId=172288&cacheKey=1405742492195807307_600576175_5.54.05&wxAppVersion=5.54.05&platform=81&tenantId=10215149&appId=wx1fde2c33280d64b6&bizType=4&multiShop=1&orderChannel=91'
                },
            ],
            tYear: null,
        }
    },
    computed:{
        store_open: function() {
            let n = 0;
            this.storeList.filter(item=>{
                if(item.opening){
                    n++
                }
            })
            return n
        },
        store_ready: function() {
            let n = 0;
            this.storeList.filter(item=>{
                if(!item.opening){
                    n++
                }
            })
            return n
        },
    },
    created:function(){
        var myDate = new Date();
        this.tYear = myDate.getFullYear();
    },
    mounted:function(){
        let that = this;
        that.$refs.player.addEventListener('play',function(){
            that.videoStatus = true;
        });
        that.$refs.player.addEventListener('pause',function(){
            that.videoStatus = false;
        });
        that.$nextTick(() => {
            document.addEventListener("scroll", () => {
                that.handleScroll();
            });
        });
    },
    beforeDestroy () {
        document.removeEventListener('scroll', this.handleScroll());
    },
    methods:{
        handleScroll() {
            let that = this;
            let currrentTop = document.documentElement.scrollTop;
            if(document.getElementById('about')){
                const aboutOffsetTop = document.getElementById('about').offsetTop - 73;
                const storyOffsetTop = document.getElementById('story').offsetTop - 73;
                const storeOffsetTop = document.getElementById('store').offsetTop - 73;
                const shopOffsetTop = document.getElementById('shop').offsetTop - 73;
                if( currrentTop >= aboutOffsetTop && currrentTop < storyOffsetTop ) {
                    that.currentIndex = 1;
                }else if( currrentTop >= storyOffsetTop && currrentTop < storeOffsetTop ) {
                    that.currentIndex = 2;
                }else if( currrentTop >= storeOffsetTop && currrentTop < shopOffsetTop ) {
                    that.currentIndex = 3;
                }else{
                    that.currentIndex = 0;
                }
            }
            if(that.$refs.picStory) {
                if (isElementNotInViewport(that.$refs.aboutBox)) {
                    that.$refs.picStory.style.position = 'fixed';
                } else {
                    that.$refs.picStory.style.position = 'absolute';
                }
            }
        },
        showShop() {
            this.temporaryIndex = this.currentIndex;
            this.currentIndex = 4;
        },
        hideShop() {
            this.currentIndex = this.temporaryIndex;
        },
        tokVideo() {
            document.getElementById("video").scrollIntoView();
        },
        tokAbout() {
            this.$nextTick(() => {
                let target = document.getElementById('about').offsetTop - 72;
                window.scrollTo(0, target);
            })
        },
        tokStory() {
            this.$nextTick(() => {
                let target = document.getElementById('story').offsetTop - 72;
                window.scrollTo(0, target);
            })
        },
        tokStore() {
            this.$nextTick(() => {
                let target = document.getElementById('store').offsetTop - 72;
                window.scrollTo(0, target);
            })
        },
        play() {
            this.$refs.player.play();
        },
        beianClick() {
            window.open('https://beian.miit.gov.cn');
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/pc.css';

</style>



// WEBPACK FOOTER //
// src/components/pc_index.vue